<template>
  <WdsStack direction-column>
    <WdsStack direction-row justify-start gap-xs align-center :data-test="`tc-country-${index}`">
      <WdsIcon
        v-if="contact.country?.isoCode"
        :size="16"
        :name="computeFlagIcon(contact.country.isoCode)"
        class="tw-flex-shrink-0"
      />

      <WdsText
        :text="contact.country?.name ?? ''"
        :title="contact.country?.name ?? ''"
        primary
        class="tw-whitespace-nowrap"
      />
    </WdsStack>
    <WdsText
      secondary
      :text="getCityDetails(contact)"
      :title="getCityDetails(contact)"
      :data-test="`tc-country-details-${index}`"
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsIcon, WdsStack, WdsText } from '@worksome/wds-components'
import { TrustedContactListEntry } from '@/components/Contacts/CompanyFreelancer/composables/trustedContactsList'
import { computeFlagIcon } from '@/utils/ts-tools'

interface Props {
  contact: TrustedContactListEntry
  index: Number
}

defineProps<Props>()

const getCityDetails = (row) => {
  if ((!row.city && !row.state) || row.status === 'INVITED') {
    return '-'
  }

  const sanitizedCity =
    row.city !== ''
      ? row.city
          .toLowerCase()
          .split(' ')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      : null

  if (row.state && sanitizedCity) {
    return `${sanitizedCity}, ${row.state}`
  }

  return sanitizedCity ?? `-, ${row.state}`
}
</script>
